module.exports = "/_next/static/images/tools-3-29ab417dc2764d69f8b6277bb8f74aa3.png";